/* KALKAK · aparición suave de secciones */
(function () {
  document.documentElement.classList.add('kk-js');
  function init() {
    var els = document.querySelectorAll('.kk-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* KALKAK · textos de apps (formulario Releasit, reseñas Trustoo) en español */
(function () {
  var exactos = {
    'Shipping': 'Envío', 'Free shipping': 'Envío gratis a toda Colombia', 'Discounts': 'Descuento', 'Discount': 'Descuento',
    'envio': 'Método de envío', 'Agrega tus datos de envio': 'Agrega tus datos de envío',
    'Customer Reviews': 'Opiniones de clientes', 'Write a review': 'Escribir una opinión', 'Verified purchase': 'Compra verificada',
    'Verified Purchase': 'Compra verificada', 'Verified buyer': 'Comprador verificado', 'Most recent': 'Más recientes',
    'Highest rating': 'Mejor calificación', 'Lowest rating': 'Menor calificación', 'With photos': 'Con fotos',
    'Load more': 'Ver más', 'Show more': 'Ver más', 'Read more': 'Leer más', 'Helpful': 'Útil', 'No reviews yet': 'Aún no hay opiniones',
    'There are no reviews yet.': 'Aún no hay opiniones.', 'Be the first to write a review': 'Sé el primero en opinar',
    'Submit': 'Enviar', 'Cancel': 'Cancelar', 'Name': 'Nombre', 'Email': 'Correo', 'Rating': 'Calificación',
    'Review': 'Opinión', 'Title': 'Título', 'Reviews': 'Opiniones', 'reviews': 'opiniones', 'review': 'opinión', 'Stars': 'estrellas', 'Star': 'estrella', 'stars': 'estrellas', 'star': 'estrella'
  };
  var unidades = { minute: ['minuto', 'minutos'], hour: ['hora', 'horas'], day: ['día', 'días'], week: ['semana', 'semanas'], month: ['mes', 'meses'], year: ['año', 'años'] };
  function traducirTexto(t) {
    if (exactos[t]) return exactos[t];
    var m;
    if ((m = t.match(/^(\d+)\s+[Rr]eviews?$/))) return m[1] + (m[1] === '1' ? ' opinión' : ' opiniones');
    if ((m = t.match(/^(\d+)\s+Stars?$/))) return m[1] + (m[1] === '1' ? ' estrella' : ' estrellas');
    if ((m = t.match(/^[Bb]ased on (\d+) reviews?$/))) return 'Basado en ' + m[1] + (m[1] === '1' ? ' opinión' : ' opiniones');
    if ((m = t.match(/^(\d+|an?)\s+(minute|hour|day|week|month|year)s?\s+ago$/))) {
      var n = /^an?$/.test(m[1]) ? '1' : m[1];
      return 'hace ' + n + ' ' + unidades[m[2]][n === '1' ? 0 : 1];
    }
    return null;
  }
  function traducir(raiz) {
    if (!raiz) return;
    if (raiz.nodeType === 3) {
      var t = raiz.nodeValue.trim(), r = t && traducirTexto(t);
      if (r) raiz.nodeValue = raiz.nodeValue.replace(t, r);
      return;
    }
    if (raiz.nodeType !== 1) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t2 = n.nodeValue.trim(), r2 = t2 && traducirTexto(t2);
      if (r2) n.nodeValue = n.nodeValue.replace(t2, r2);
    }
  }
  var pendientes = [], programado = false;
  function procesar() {
    programado = false;
    var lista = pendientes; pendientes = [];
    lista.forEach(traducir);
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'characterData') pendientes.push(m.target);
      else m.addedNodes.forEach(function (n) { pendientes.push(n); });
    });
    if (!programado) { programado = true; setTimeout(procesar, 60); }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  function inicio() { traducir(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio); else inicio();
})();
